module.exports = __webpack_public_path__ + "img/grid-3x3-gap-fill.e9d741dd.svg";